
    var riot = require('riot')
    //src: starling/src/tags/menu/items/menu-item-group-selection.html
riot.tag2('menu-item-group-selection',
  '<i class="toolbar-icons group-cards floating-menu_icon"></i> <span class="floating-menu_label">Group selection</span> <span class="floating-menu_shortcut">{shortcut}</span>',
  '',
  'class="{opts.classes} floating-menu_item" onclick="{groupSelection}"', function(opts) {
'use strict';

var _util = require('lib/util');

var _eventTracking = require('lib/event-tracking');

var _eventTracking2 = _interopRequireDefault(_eventTracking);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var parent = this.parent;

var canvas = parent.opts.canvas;
var isMac = canvas.isMac;

this.shortcut = isMac ? '⌘G' : 'Ctrl+G';

this.groupSelection = function (e) {
  canvas.createSystemFromSelection();
  canvas.selectionArea.resetSelectionBox();
  canvas.bulkActionsMenuTag.update();
  canvas.hidePopups();
  parent.hide();

  _eventTracking2.default.track({
    category: (0, _util.getTrackingLabel)(parent),
    action: 'Group-Selection',
    label: 'Selection'
  });
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('menu-item-group-selection')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/menu/items/menu-item-group-selection.html
// module id = 693
// module chunks = 0